import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.what-is-sms-service', {
        url: '/what-is-sms-service',
        component: 'companySmsServicesHelpWhatIsSmsService',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/what-is-sms-service/what-is-sms-service.state.js